import { useQuery } from "@tanstack/react-query";
import Axios from "@/lib/axios-instance";

// Type for the plan response
type FeaturePlan = {
    plan_id: string;
    plan_name: string;
    is_active: boolean;
    plan_created_at: string | number;
    plan_price: string;
    plan_description: string;
    plans_interval: string;
};

type GetAllFeaturePlansResponse = {
    data: FeaturePlan[];
    meta?: any;
};

type Props = {
    search?: string | null;
    is_active?: string | undefined; // Accepts "true", "false", or undefined
};

// API call to get all plan features
export const getAllFeaturePlans = async (search?: string | null, is_active?: string | undefined) => {
    let url = "/plan_feature";

    // Build query parameters
    const params = new URLSearchParams();
    if (search) {
        params.append('search', search);
    }
    if (is_active) {
        params.append('is_active', is_active);
    }

    // Only add query parameters if they exist
    if (params.toString()) {
        url += `?${params.toString()}`;
    }

    const response = await Axios.get<GetAllFeaturePlansResponse>(url);
    return response.data;
};

// React Query hook
export const useGetAllFeaturePlans = ({ search, is_active }: Props = { search: undefined, is_active: undefined }) => {
    return useQuery({
        queryKey: ["get-all-feature-plans", search, is_active],
        queryFn: () => getAllFeaturePlans(search, is_active),
        staleTime: 5 * 60 * 1000, // Optional: keeps data fresh for 5 minutes
        retry: 1, // Optional: retry once on failure
    });
};
